export const START_ROUTE_NAME_OF_INSURANCE_REQUEST = 'TariffZipcode'

export const shouldSkipRoute = (route) => {
  if (route.meta && route.meta.shouldSkip) {
    const { shouldSkip } = route.meta
    return shouldSkip()
  }
  return false
}

export const getNextRouteName = (route) => {
  const { nextRoute } = route.meta
  const routeName = typeof nextRoute === 'function' ? nextRoute() : nextRoute
  return routeName
}

export const getPreviousRouteName = (route) => {
  const { previousRoute } = route.meta
  const routeName = typeof previousRoute === 'function' ? previousRoute() : previousRoute
  return routeName
}

const applyMetaResolver = (to) => to.meta.beforeResolve && to.meta.beforeResolve()

export const validateAndResolveNewRoute = (to) => {
  let newRouteName = null
  const newRouteParams = {}

  const resolvedRoute = applyMetaResolver(to)

  if (resolvedRoute) {
    newRouteName = resolvedRoute
  } else if (shouldSkipRoute(to)) {
    newRouteName = getNextRouteName(to)
  }

  if (newRouteName) {
    return {
      routeName: newRouteName,
      routeParams: newRouteParams,
    }
  }
  return null
}
